import {BaseAuditMixin, BaseAuditMixinAttributes, BaseAuditMixinRelationships} from "./base-audit-mixin";
import {ModelID} from "../_typing/generic-types";
import {DEFAULT, SINGLE_RELATIONSHIP_TYPE} from "./shared-types";

export class ConfigurationAttributes extends BaseAuditMixinAttributes {
    name: string;
    config_type: 'plaintext' | 'encrypted' | 'json';
    value: any;
}

export class ConfigurationRelationships extends BaseAuditMixinRelationships {
    account: SINGLE_RELATIONSHIP_TYPE = DEFAULT.SINGLE;
}

export class Configuration extends BaseAuditMixin {
    id: string;
    attributes: ConfigurationAttributes;
    relationships: ConfigurationRelationships;
    type: string = 'configuration';

    constructor() {
        super();
        this.attributes = new ConfigurationAttributes();
        this.relationships = new ConfigurationRelationships();
    }
}

export class PageDatePeriodValue {
    calendar_id?: ModelID;
    range?: string;
    sample_period?: string;

    constructor() {
    }
}
